export default __webpack_public_path__ + "static/media/bg2.57009288.jpg";